import React, { useState } from 'react';
import { Gift, ChevronDown, Sparkles } from 'lucide-react';
interface Bonus {
  title: string;
  pages: string;
  items: string[];
}
const bonuses: Bonus[] = [{
  title: 'BONO 1 — Atlas Visual de Instrumental Quirúrgico',
  pages: '30 páginas',
  items: ['Fotos explicadas', 'Comparativas visuales', 'Diferencias rápidas', 'Guía visual de reconocimiento']
}, {
  title: 'BONO 2 — Checklists Hospitalarias Imprimibles',
  pages: '20–30 páginas',
  items: ['Checklist prequirúrgica', 'Checklist de esterilidad', 'Conteo quirúrgico', 'Preparación de mesa']
}, {
  title: 'BONO 3 — Guía Rápida por Especialidad',
  pages: '20–30 páginas',
  items: ['Cirugía general', 'Traumatología', 'Ginecología', 'Neurocirugía', 'Pediatría']
}, {
  title: 'BONO 4 — Simulacros de Examen y Casos Clínicos',
  pages: '20–30 páginas',
  items: ['Preguntas frecuentes', 'Casos prácticos', 'Resolución paso a paso', 'Simulación oral/práctica']
}, {
  title: 'BONO 5 — Manual de Errores Críticos en Quirófano',
  pages: '20–30 páginas',
  items: ['Contaminación', 'Fallas de conteo', 'Entrega incorrecta', 'Cómo prevenir errores graves']
}];
export const Bonuses: React.FC = () => {
  const [openBonus, setOpenBonus] = useState<number | null>(0);
  const toggleBonus = (index: number) => {
    setOpenBonus(openBonus === index ? null : index);
  };
  return <section className="w-full bg-cyan-900 py-16 px-4 sm:px-6 lg:px-8 text-white" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <div className="text-center mb-10" data-id="element-15">
          <div className="inline-flex items-center gap-2 bg-cyan-800 px-4 py-2 rounded-full text-cyan-200 font-semibold text-sm mb-4" data-id="element-16">
            <Gift className="w-4 h-4" data-id="element-17" />
            <span data-id="element-18">OFERTA ESPECIAL</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold mb-3" data-id="element-19">
            Llevate estos 5 BONOS GRATIS por el día de hoy
          </h2>
          <p className="text-cyan-100 text-base sm:text-lg max-w-2xl mx-auto" data-id="element-20">
            Recursos complementarios para potenciar tu aprendizaje y sentirte
            preparado en cada rotación hospitalaria.
          </p>
        </div>

        <div className="space-y-3" data-id="element-21">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white text-slate-900 rounded-xl shadow-md overflow-hidden border border-cyan-700/30" data-id="element-22">
              <button onClick={() => toggleBonus(index)} className="w-full flex items-center justify-between p-4 sm:p-5 text-left hover:bg-slate-50 transition-colors" data-id="element-23">
                <div className="flex items-center gap-3" data-id="element-24">
                  <div className={`p-2 rounded-lg flex-shrink-0 ${openBonus === index ? 'bg-cyan-100 text-cyan-700' : 'bg-slate-100 text-slate-500'}`} data-id="element-25">
                    <Sparkles className="w-5 h-5" data-id="element-26" />
                  </div>
                  <h3 className="font-bold text-sm sm:text-base text-slate-900 pr-2" data-id="element-27">
                    {bonus.title}
                  </h3>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0" data-id="element-28">
                  <span className="hidden sm:inline-block bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded-full" data-id="element-29">
                    GRATIS HOY
                  </span>
                  <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openBonus === index ? 'rotate-180' : ''}`} data-id="element-30" />
                </div>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openBonus === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-31">
                <div className="px-5 pb-5 pt-1 border-t border-slate-100 bg-slate-50/50" data-id="element-32">
                  <p className="text-xs font-semibold text-cyan-700 uppercase tracking-wide mt-3 mb-3" data-id="element-33">
                    {bonus.pages}
                  </p>
                  <ul className="space-y-2" data-id="element-34">
                    {bonus.items.map((item, iIndex) => <li key={iIndex} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-35">
                        <span className="text-cyan-600 mt-0.5 font-bold" data-id="element-36">
                          ›
                        </span>
                        <span data-id="element-37">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};